import { useState, useCallback, useEffect } from "react";
import "@/App.css";
import { translations } from "@/lib/i18n";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Gallery from "@/components/Gallery";
import WhyChoose from "@/components/WhyChoose";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

function App() {
  // Get language from localStorage or default to 'az'
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('orkhan-language');
    return saved && translations[saved] ? saved : 'az';
  });

  // Get translations for current language
  const t = translations[language];

  // Handle language change
  const handleLanguageChange = useCallback((lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      localStorage.setItem('orkhan-language', lang);
      document.documentElement.lang = lang;
    }
  }, []);

  // Update html lang attribute on mount
  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return (
    <div className="App bg-[#050505] min-h-screen overflow-x-clip">
      <Navbar 
        language={language} 
        onLanguageChange={handleLanguageChange} 
        t={t} 
      />
      <main>
        <Hero t={t} />
        <About t={t} language={language} />
        <Services t={t} />
        <Gallery t={t} />
        <WhyChoose t={t} />
        <Testimonials t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
      <FloatingWhatsApp t={t} />
    </div>
  );
}

export default App;
